// placeholder for the index file, add the export statements here
import RackbeatLagerOnboardingDialog from './main';

export default RackbeatLagerOnboardingDialog;
